import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "../../Styles/Itinerary.module.scss";
import itinerary from "../../img/Turkey/Itinerary_Turkey.pdf";
import { IoClose } from "react-icons/io5";
import pictureOne from "./../../img/Turkey/Itinerary_1_Patmos.jpg";
import pictureTwo from "./../../img/Turkey/Itinerary_2_Top_of_Pergamos.jpg";
import pictureThree from "./../../img/Turkey/Itinerary_3_Istanbul.jpg";

function TurkeyItinerary() {
  const tripOne = [
    {
      day: "Day 1, Wednesday, September 24",
      text: "Depart USA."
    },
    {
      day: "Day 2, Thursday, September 25",
      text: "Arrive Istanbul and get to hotel. (overnight in Istanbul)"
    },
    {
      day: "Day 3, Friday, September 26",
      text: "Tour Istanbul: Hagios Sofia, cruise on the Bosphorus, and more. (overnight in Istanbul)"
    },
    {
      day: "Day 4, Saturday, September 27",
      text: "Fly to Izmir and transfer to see Smyrna Agora and new Museum. (overnight in Kusadasi) (B,D)"
    },
    {
      day: "Day 5, Sunday, September 28",
      text: "A day boat trip to the Island of Patmos: Cave of the Apocalypse (overnight Kusadasi) (B,D)"
    },
    {
      day: "Day 6, Monday, September 29",
      text: "Ephesus (overnight Kusadasi) (B,D)."
    },
    {
      day: "Day 7, Tuesday, September 30",
      text: "Visit Priene, Miletus, Didyma (overnight Izmir) (B,D)"
    },
    {
      day: "Day 8, Wednesday, October 1",
      text: "Pergamum with Acropolis and Asklepion; Thyatira (overnight Salihli) (B,D)"
    },
    {
      day: "Day 9, Thursday, October 2",
      text: "Sardis, Philadelphia, Hierapolis (overnight Pamukkale) (B,D)"
    },
    {
      day: "Day 10, Friday, October 3",
      text: "Laodicea and Colossae; drive to Antalya (overnight Antalya)(B,D)"
    },
    {
      day: "Day 11, Saturday, October 4",
      text: "Magydos waterfalls, Perga, lunch at St. Paul Cultural Center; Walking tour of Attalia and new Necropolis Museum (overnight Antalya) (B,D)"
    },
    {
      day: "Day 12, Sunday, October 5",
      text: "Fly to Istanbul in the AM and to the USA in the PM"
    }
  ];

  const [justTrip, setJustTrip] = useState(false);
  const tripExample = [
    {
      day: "Day 1",
      text: "Depart USA."
    },
    {
      day: "Day 2",
      text: "Arrive Istanbul and get to hotel. (overnight in Istanbul)"
    },
    {
      day: "Day 3",
      text: "Tour Istanbul: Hagios Sofia, cruise on the Bosphorus, and more.(overnight in Istanbul)"
    },
    {
      day: "Day 4",
      text: "Fly to Izmir and transfer to see Smyrna Agora and new Museum. (overnight in Kusadasi) (B,D)"
    },
    {
      day: "Day 5",
      text: "A day boat trip to the Island of Patmos: Cave of the Apocalypse (overnight Kusadasi) (B,D)"
    },
    {
      day: "Day 6",
      text: "Ephesus (overnight Kusadasi) (B,D)"
    },
    {
      day: "Day 7",
      text: "Visit Priene, Miletus, Didyma (overnight Izmir) (B,D)"
    },
    {
      day: "Day 8",
      text: "Pergamum with Acropolis and Asklepion; Thyatira (overnight Salihli) (B,D)"
    },
    {
      day: "Day 9",
      text: "Sardis, Philadelphia, Hierapolis (overnight Pamukkale) (B,D)"
    },
    {
      day: "Day 10",
      text: "Laodicea and Colossae; drive to Antalya (overnight Antalya)(B,D)"
    },
    {
      day: "Day 11",
      text: "Magydos waterfalls, Perga, lunch at St. Paul Cultural Center; Walking tour of Attalia and new Necropolis Museum (overnight Antalya) (B,D)"
    },
    {
      day: "Day 12",
      text: "Fly to Istanbul in the AM and to the USA in the PM"
    }
  ];

  const params = useParams();

  let dates = "";
  let itinerary = "";
  let trip = [];
  console.log(params.trip);

  switch (params.trip) {
    case "October-2026":
      dates = "September 29 - October 13, 2026";
      trip = tripOne;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }

  useEffect(() => {
    if (params.trip === "trip") {
      setJustTrip(true);
      console.log(trip);
    } else {
      setJustTrip(false);
      console.log(trip);
    }
  }, []);
  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">Tour of Turkey</p>
      <p className="secondaryTitle">{dates}</p>
      {!justTrip ? (
        <div className="printBox">
          <div className="print">
            <a href={itinerary} target="_blank" rel="noreferrer">
              Print PDF
            </a>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Poland town" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Poland solt mines" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Polamd mountains" />
        </div>
      </div>
      {trip.map((el, i) => (
        <div key={i}>
          <h2 className={styles.dayNumber}>{el.day}</h2>
          <p className="text">{el.text}</p>
        </div>
      ))}
    </div>
  );
}

export default TurkeyItinerary;
